export const MOBILE_MAX_BREAKPOINT = 768;
export const SMALL_MAX_BREAKPOINT = 1023;
export const MEDIUM_MAX_BREAKPOINT = 1280;
export const LARGE_MAX_BREAKPOINT = 1440;
export const EXTRA_LARGE_MAX_BREAKPOINT = 1680;

export const FOOTER_MAX_WIDTH = SMALL_MAX_BREAKPOINT;
export const LANDING_PAGE_MAX_WIDTH = LARGE_MAX_BREAKPOINT;
export const PAPER_BROWSER_GRID_PAGE_MAX_WIDTH = EXTRA_LARGE_MAX_BREAKPOINT;

export const MOBILE_END_QUERY = 'max-width: ' + MOBILE_MAX_BREAKPOINT + 'px';

export const DESKTOP_START_QUERY =
  'min-width: ' + (MOBILE_MAX_BREAKPOINT + 1) + 'px';
export const DESKTOP_SMALL_MAX_QUERY =
  'min-width: ' + (SMALL_MAX_BREAKPOINT + 1) + 'px';
export const DESKTOP_MEDIUM_START_QUERY =
  'min-width: ' + SMALL_MAX_BREAKPOINT + 'px';
export const DESKTOP_MEDIUM_MAX_QUERY =
  'max-width: ' + MEDIUM_MAX_BREAKPOINT + 'px';
export const DESKTOP_LARGE_START_QUERY =
  'min-width: ' + (MEDIUM_MAX_BREAKPOINT + 1) + 'px';
export const DESKTOP_BELOW_MAX_QUERY =
  'max-width: ' + LARGE_MAX_BREAKPOINT + 'px';
export const DESKTOP_ABOVE_MAX_QUERY =
  'min-width: ' + (LARGE_MAX_BREAKPOINT + 1) + 'px';

// Themes for the ENTIRE PAGE on landing pages
export const LANDING_PAGE_LAYOUT_THEMES = {
  mobile: 'FlexboxGridMobileTheme',
  small: 'FlexboxGridDesktopSmallTheme',
  medium: 'FlexboxGridDesktopMediumTheme',
  large: 'FlexboxGridDesktopLargeTheme',
  xLarge: 'FlexboxGridDesktopLargeTheme',
};

// Themes for the ENTIRE PAGE in the paper browser
export const PAPER_BROWSER_LAYOUT_THEMES = {
  mobile: 'FlexboxGridTheme',
  small: 'FlexboxGridTheme',
  medium: 'FlexboxGridWithNavTheme',
  large: 'FlexboxGridWithNavTheme',
  xLarge: 'FlexboxGridWithNavTheme',
};

// Themes for the CARD GRID in the paper browser
export const PAPER_BROWSER_GRID_THEMES = {
  mobile: 'FlexboxGridMobileTheme',
  small: 'FlexboxGridDesktopSmallTheme',
  medium: 'FlexboxGridDesktopMediumTheme',
  large: 'FlexboxGridDesktopLargeTheme',
  xLarge: 'FlexboxGridDesktopLargeTheme',
};

export const PAPER_BROWSER_GRID_COLUMN_MAP = {
  mobile: 2,
  small: 3,
  medium: 3,
  large: 4,
  xLarge: 4,
};

export function isMobile(width): boolean {
  return width <= MOBILE_MAX_BREAKPOINT;
}

// Grid page layout allows for larger page widths, up to 1680px.
// Landing page layout allows up to a max of 1440px width.
// Landing pages handle this by using landingPageLayoutSizeConverter in "src/applications/LandingPage/Router.js"
// Failsafe to mobile sizing
export function layoutSize(width): string {
  if (width > LARGE_MAX_BREAKPOINT) {
    return 'xLarge';
  } else if (width > MEDIUM_MAX_BREAKPOINT && width <= LARGE_MAX_BREAKPOINT) {
    return 'large';
  } else if (width > SMALL_MAX_BREAKPOINT && width <= MEDIUM_MAX_BREAKPOINT) {
    return 'medium';
  } else if (width > MOBILE_MAX_BREAKPOINT && width <= SMALL_MAX_BREAKPOINT) {
    return 'small';
  } else {
    return 'mobile';
  }
}
